import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCoins: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCoins"><Path d="M13.959 5.05956C9.47883 5.57556 6 9.38152 6 14C6 14.8599 6.1206 15.6917 6.34582 16.4793C3.79594 15.4336 2 12.9266 2 10C2 6.13401 5.13401 3 9 3C10.9377 3 12.6916 3.78734 13.959 5.05956Z" fill="currentColor"/><Path d="M22 14C22 17.866 18.866 21 15 21C11.134 21 8 17.866 8 14C8 10.134 11.134 7 15 7C18.866 7 22 10.134 22 14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCoins;
